export default __webpack_public_path__ + "static/media/projects_small.546e5c87.svg";